import { render, staticRenderFns } from "./PaymentMain.vue?vue&type=template&id=65f52584&scoped=true&"
import script from "./PaymentMain.vue?vue&type=script&lang=js&"
export * from "./PaymentMain.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMain.vue?vue&type=style&index=0&id=65f52584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f52584",
  null
  
)

export default component.exports